module.exports = __webpack_public_path__ + "img/icon_map_1_hg_c.14e806e6.png";